// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "d1cb12a",
    "hash": "d1cb12a",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "d1cb12a",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
